














































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import configForm from "@components/common/form.vue";
import selectItem from "@components/common/formItem/selectItem.vue";
import textItem from "@components/common/formItem/textItem.vue";
import inputItem from "@components/common/formItem/inputItem.vue";
import linkItem from "@components/common/formItem/linkItem.vue";
import radioItem from "@components/common/formItem/radioItem.vue";
import amountItem from "@components/common/formItem/amountItem.vue";
import jump from "@lib/mixins/jump";
// import applySuccess from "./components/applySuccess.vue";
// import noApply from "./components/noApply.vue";
const taxFilingModule = namespace("vatTaxFiling");
const rootModule = namespace("app");
const indexModule = namespace("index");
Component.registerHooks(["beforeRouteEnter"]);
@Component({
  components: {
    configForm
    // applySuccess,
    // noApply
  },
  mixins: [jump]
})
export default class TaxFilingConfirm extends Vue {
  @taxFilingModule.Getter("confirmInfo")
  private confirmInfo: any;
  // @taxFilingModule.Getter("poundage")
  private poundage: any = {};
  private allPoundage: any = [];
  @taxFilingModule.Action("applyTaxFiling")
  private applyTaxFiling: any;

  @rootModule.Getter("country")
  private country: any;
  @indexModule.Getter("baseInfo")
  private baseInfo: any;

  private nations: any = [];
  // 协议
  private agreementChecked: boolean = false;
  // 按钮属性
  private get btnDisabled() {
    return !this.poundage;
  }
  private loading: boolean = false;

  // 当前付费方式
  private currentPayType: any = "filing_one_year";
  // 表单属性
  private formParam: any = {};
  private get formOption() {
    return {};
  }

  // 表单传进来的数据
  private get formData() {
    // let amount = 0
    // this.allPoundage.forEach((poundage: any) => {
    //   if (poundage.payType === "filing_one_year") {
    //     amount = poundage;
    //   }
    // });
    return {
      // companyName: this.cipInfo.enterpriseName,
      // corporation: this.cipInfo.applicantName,
      // companyAddress: this.accountInfo.address,
      // nation: this.nations[0] ? this.nations[0].nation : "",
      amount: this.poundage.amount,
      email: this.baseInfo.email,
      payType: this.currentPayType
    };
  }

  private get formConfig() {
    const payTypeArray: any[] = [];
    this.allPoundage.forEach((poundage: any) => {
      if (poundage.nation === this.confirmInfo.nation) {
        payTypeArray.push(poundage.payType);
      }
    });
    console.log('payTypeArray', payTypeArray)
    return [
      {
        value: "nation",
        name: this.$t("vatTaxFiling.applyNation"),
        component: "textItem",
        componentVue: textItem,
        style: {},
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        notParam: true,
        render: (data: any) => {
          return this.confirmInfo.nation
            ? this.$t(`app.nation.${this.confirmInfo.nation}`)
            : "";
        }
      },
      {
        value: "storeLength",
        name: this.$t("vatTaxFiling.applyStore"),
        component: "textItem",
        componentVue: textItem,
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        notParam: true,
        render: () => {
          return this.confirmInfo.storeList.length
            ? `${this.confirmInfo.storeList.length}${this.$t(
                "vatTaxFiling.num"
              )}`
            : `${this.$t("vatTaxFiling.none")}`;
        }
      },
      {
        value: "storeNames",
        name: this.$t("vatTaxFiling.applyStoreName"),
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        textStyle: {
          "margin-left": "126px"
        },
        component: "textItem",
        componentVue: textItem,
        notParam: true,
        render: (row: any) => {
          const stores: any = [];
          if (this.confirmInfo.storeList && this.confirmInfo.storeList.length) {
            this.confirmInfo.storeList.forEach((data: any) => {
              stores.push(data.name);
            });
            return _.join(stores, "、");
          } else {
            return `${this.$t("vatTaxFiling.none")}`;
          }
        }
      },
      {
        value: "agent",
        name: this.$t("vatTaxFiling.applyAgent"),
        notParam: true,
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        component: "textItem",
        componentVue: textItem,
        render: () => {
          return "PingPong";
        }
      },
      {
        value: "payee",
        name: this.$t("vatTaxFiling.payee"),
        component: "textItem",
        componentVue: textItem,
        labelStyle: {
          width: "150px",
          height: "40px"
        },
        notParam: true,
        render: () => {
          return "PING PONG GLOBAL HOLDINGS LIMITED";
        }
      },
      {
        value: "payType",
        name: this.$t("vatTaxFiling.payType"),
        component: "radioItem",
        componentVue: radioItem,
        style: {
          "border-bottom": "1px solid rgba(0,0,0,0.08)"
        },
        labelStyle: {
          width: "150px",
          height: "50px"
        },
        options: [
          {
            value: this.$t("app.payType.filing"),
            key: "filing",
            hidden: !payTypeArray.includes('filing')
          },
          {
            value: this.$t("app.payType.filing_one_year"),
            key: "filing_one_year",
            hidden: !payTypeArray.includes('filing_one_year'),
            tips: this.$t("app.payTypeTip"),
            tag: this.$t("app.discount")
          },
          {
            value: this.$t("app.payType.history_or_other"),
            key: "history_or_other",
            hidden: !payTypeArray.includes('history_or_other')
          }
        ],
        change: async (data: any) => {
          console.log(data, this.formParam.payType);
          this.currentPayType = data;
          this.allPoundage.forEach((poundage: any) => {
            if (
              poundage.payType === data &&
              poundage.nation === this.confirmInfo.nation
            ) {
              this.poundage = poundage;
            }
          });
        }
      },
      {
        value: "amount",
        name: this.$t("vatTaxFiling.applyAmount"),
        show: this.currentPayType !== "history_or_other",
        component: "amountItem",
        componentVue: amountItem,
        rules: [
          {
            required: true,
            trigger: "blur",
            message: " "
          }
        ],
        style: {
          "padding-top": "30px",
          "padding-bottom": "10px",
          "border-bottom": "1px solid rgba(0,0,0,0.08)"
        },
        labelStyle: {
          width: "150px",
          height: "50px"
        },
        textStyle: {
          color: "#1FA0E8"
        },

        itemType: "text",

        render: (row: any) => {
          const str = `${this.$ppFilter.money(this.poundage.amount)} ${
            this.poundage.currency
          }`;
          return str;
        },
        getTip: (row: any) => {
          if (
            this.formParam.payType === "filing_one_year" &&
            this.poundage.discount
          ) {
            return `${this.$t("app.hasDiscount", {
              data: this.poundage.discount + `${this.poundage.currency}`
            })}`;
          } else if (this.formParam.payType === "history_or_other") {
            return `${this.$t("app.hasQuestion")}`;
          }
        }
      },
      {
        value: "amount",
        name: this.$t("vatTaxFiling.applyInputAmount"),
        show: this.currentPayType === "history_or_other",
        rules: [
          {
            required: true,
            trigger: "blur",
            message: " "
          }
        ],
        component: "amountItem",
        componentVue: amountItem,
        style: {
          "padding-top": "30px",
          "padding-bottom": "10px",
          "border-bottom": "1px solid rgba(0,0,0,0.08)"
        },
        labelStyle: {
          width: "150px",
          height: "50px"
        },
        textStyle: {
          color: "#1FA0E8"
        },
        currency: "EUR",
        itemType: "input",
        placeholder: `${this.$t("vatTaxFiling.amountPrompt")}`,
        getTip: (row: any) => {
          return `${this.$t("app.hasQuestion")}`;
        }
      },
      {
        value: "email",
        name: this.$t("vatTaxFiling.applyEmail"),
        style: {
          "margin-top": "20px"
        },
        labelStyle: {
          width: "150px",
          height: "50px"
        },
        component: "textItem",
        componentVue: textItem,
        tips: `（${this.$t("vatTaxFiling.applyEmailTip")}）`
      },
      {
        value: "link",
        name: this.$t("vatTaxFiling.applyLink"),
        labelStyle: {
          width: "150px",
          height: "50px"
        },
        style: {
          "border-bottom": "1px solid rgba(0,0,0,0.08)"
        },
        component: "linkItem",
        componentVue: linkItem,
        notParam: true,
        click: (data: any) => {
          this.$href({
            fullPath: `#/agreement/vat-taxFiling`,
            open: true
          });
        },
        render: (data: any) => {
          return this.$t("index.toDetail");
        }
      }
    ];
  }
  // 申请按钮
  private async apply() {
    const applyForm: any = this.$refs.applyForm;
    const defaultForm: any = applyForm.$refs.defaultForm;

    const accIds: any = [];
    this.confirmInfo.storeList.forEach((data: any) => {
      accIds.push(data.accId);
    });
    console.log(applyForm, defaultForm);
    defaultForm.validate(async (valid: any) => {
      if (valid) {
        const result: any = await this.$block.dispatch(
          "vatTaxFiling/submitApplies",
          {
            data: {
              nation: this.confirmInfo.nation,
              accIds: accIds,
              payType: this.formParam.payType,
              amount: this.formParam.amount,
              currency: this.poundage.currency
            }
          }
        );
        console.log(result);
        if (result)
          this.$router.push({
            name: "vatTaxFilingSuccess",
            params: { applyNo: result.applyNo }
          });
      }
    });
  }
  private async mounted() {
    const allResultPoundage = await this.$block.dispatch(
      "vatTaxFiling/getFilingNations",
      {
        params: {}
      }
    );
    this.allPoundage = allResultPoundage;
    console.log(this.allPoundage);
    this.allPoundage.forEach((poundage: any) => {
      if (
        poundage.payType === this.currentPayType &&
        poundage.nation === this.confirmInfo.nation
      ) {
        this.poundage = poundage;
      }
    });
  }
  private beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (vm.confirmInfo.nation) {
        // ccfx白名单
        next();
      } else {
        vm.$message.warning(`${vm.$t("vatTaxFiling.chooseStore")}`);
        next("/vatTaxFiling/apply");
      }
    });
  }
  // 销毁钩子
  private async destroyed() {
    this.applyTaxFiling({
      nation: "",
      storeList: []
    });
  }
}
